import { forwardRef } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

import { hasRenderableHelperText } from '../utils/general';
import { FORM_CONTROL_LABEL_BASE_SX } from './constants';
import { buildCheckboxSx, getCheckboxColor, mergeSxProps } from './utils/general';
import { CheckboxCheckedIcon, CheckboxIcon } from './components/FCheckboxIcons';

import type { FCheckboxProps } from './types';

const FCheckbox = forwardRef<HTMLButtonElement, FCheckboxProps>(function FCheckbox(props, ref) {
  const {
    label,
    helperText,
    error = false,
    required = false,
    disabled = false,
    sx,
    formControlLabelProps,
    ...rest
  } = props;

  const helperPresent = hasRenderableHelperText(helperText);
  const checkboxColor = getCheckboxColor(error);
  const { sx: formControlLabelSx, ...restFormControlLabelProps } = formControlLabelProps ?? {};

  const mergedCheckboxSx = mergeSxProps(buildCheckboxSx(error), sx);
  const mergedFormControlLabelSx = mergeSxProps(FORM_CONTROL_LABEL_BASE_SX, formControlLabelSx);

  return (
    <FormControl error={error} disabled={disabled} required={required} component="div">
      <FormControlLabel
        {...restFormControlLabelProps}
        required={required}
        disabled={disabled}
        label={label}
        control={
          <Checkbox
            ref={ref}
            disableRipple
            icon={<CheckboxIcon color={checkboxColor} />}
            checkedIcon={<CheckboxCheckedIcon color={checkboxColor} />}
            {...rest}
            sx={mergedCheckboxSx}
          />
        }
        sx={mergedFormControlLabelSx}
      />
      {helperPresent ? (
        <FormHelperText
          component="span"
          sx={{ marginInline: 0, marginTop: 0.1, textAlign: 'start', width: '100%' }}
        >
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
});

export default FCheckbox;
